import {
    CATEGORY_ACCOUNT_DEBIT_VIA_MODULR,
    CATEGORY_TRANSFER_FROM_BANK_ACCOUNT,
    CATEGORY_TRANSFER_FROM_BANK_OFAKIM,
    CATEGORY_TRANSFER_FROM_INTERAC,
    CATEGORY_TRANSFER_FROM_PEOPLE_TRUST_INTERAC,
    CATEGORY_TRANSFER_FROM_TINK,
    CATEGORY_TRANSFER_FROM_USA_BANK_ACCOUNT,
    CATEGORY_TRANSFER_TO_ALIPAY,
    CATEGORY_TRANSFER_TO_BANK_ACCOUNT,
    CATEGORY_TRANSFER_TO_CARD,
    CATEGORY_TRANSFER_TO_CARD_VIA_PHONE_NUMBER,
    CATEGORY_TRANSFER_TO_CASH,
    CATEGORY_TRANSFER_TO_CASH_UNITELLER,
    CATEGORY_TRANSFER_TO_GCASH_WALLET,
    CATEGORY_TRANSFER_TO_GLOBAL_ACCOUNT,
    CATEGORY_TRANSFER_TO_HOME_DELIVERY,
    CATEGORY_TRANSFER_TO_INTERAC,
    CATEGORY_TRANSFER_TO_LIBRE,
    CATEGORY_TRANSFER_TO_PEOPLE_TRUST_INTERAC,
    CATEGORY_TRANSFER_TO_REMITEE,
    CATEGORY_TRANSFER_TO_SEPA,
    CATEGORY_TRANSFER_TO_UNIONPAY_CARD,
    CATEGORY_TRANSFER_TO_UNITELLER_MASTER_CARD,
    CATEGORY_TRANSFER_TO_UPI,
    CATEGORY_TRANSFER_TO_VISA_CARD,
    CATEGORY_TRANSFER_TO_WALLET,
    CATEGORY_TRANSFER_TO_WECHAT,
    CATEGORY_TRANSFER_VIA_SWIFT,
    INCOMING,
    OUT_GOING_ML,
    OUTOGOING,
    PS_BONUS_INCOMING,
    STATUS_OK,
    STATUS_SENDING_70,
    STATUS_SENDING_INTERAC,
} from 'apps/auth/constants/Constants';
import { PAKISTAN, VIETNAM } from 'apps/auth/constants/WellKnownCountries';
import { resolveArguments } from 'apps/auth/helpers/utils';

interface ChequeExtra {
    draftCompletedVerification?: boolean;
    fraudNeedFieldsInfo?: boolean;
    fraudCompletedVerification?: boolean;
    draftOnfidoTooManyAttempts?: boolean;
    draftInProgressShowSupportButton?: boolean;
    fraudNeedChat?: boolean;
    draftOnfidoCheckError?: boolean;
    draftSkippedVerification?: boolean;
    fraudManualCheck?: boolean;
    fraudChequeRecipientDetails?: boolean;
    fraudAddressValidation?: boolean;
    fraudIncreaseLimitDetails?: boolean;
    fraudCardValidation?: boolean;
}

interface TransferRecord {
    draft?: boolean;
    draftFraud?: boolean;
    providerFromCategory?: number;
    providerToCategory?: number;
    status?: number | string;
    transactionType?: string;
    secretCode?: string | null;
    billId?: number;
    avatar?: string | null;
    toCountryId?: number | string | null;
    extra?: ChequeExtra;
    toBankCountryCode?: string | null;
    waitingVerification?: boolean;
    toInteracPaymentType?: string | null;
    fromBankAccountStatusBean?: unknown;
    fromPlaid?: boolean;
    vietcombank?: boolean;
}

interface Bill {
    incoming?: boolean;
    status?: string;
    direction?: string;
}

interface HistoryMessages {
    [key: string]: string | undefined;
    chequeBlockToCard?: string;
    chequeBlockToMobile?: string;
    chequeBlockToCardViaMobile?: string;
    chequeBlockToWallet?: string;
    chequeBlockToAccount?: string;
    blockToCash?: string;
    blockToUniteller?: string;
    chequeBlockToHomeDelivery?: string;
    chequeBlockToInterac?: string;
    chequeStatusInProgress?: string;
    draftChequeStatus?: string;
    chequeStatus70specialTitle?: string;
    chequeInteracStatusInProgress?: string;
    chequeCashStatusInProgress?: string;
    chequeCashStatusNotVietcombankInProgress?: string;
    chequeHomeDeliveryStatusInProgress?: string;
    chequeInteracStatusSuccess?: string;
    chequeHomeDeliveryStatusSuccess?: string;
    chequeStatusWaitingVerification?: string;
    chequeFromInteracStatusInProgress?: string;
    chequeStatus70specialSubtitle?: string;
    chequeInteracStatusAutoDepositInfo?: string;
}

interface LastStatus {
    statusMsg?: string;
    statusDescription?: string;
}

const toNumberStatus = (status?: number | string): number => {
    if (typeof status === 'number') {
        return status;
    }
    if (typeof status === 'string' && status.trim().length > 0) {
        const parsed = Number(status);
        return Number.isNaN(parsed) ? NaN : parsed;
    }
    return NaN;
};

export const getDirectionClass = (transactionType?: string): string => {
    return OUT_GOING_ML === transactionType ? INCOMING : OUTOGOING;
};

export const showErrorType = (val: number | string): string => {
    switch (val) {
        case 616:
        case 618:
            return 'SANCTION';
        default:
            return 'NO INFO';
    }
};

export const showActionButtons = (record: TransferRecord): boolean => {
    const status = toNumberStatus(record.status);

    if (record.draft) {
        return false;
    } else if (
        record.providerFromCategory === CATEGORY_TRANSFER_FROM_BANK_ACCOUNT ||
        record.providerFromCategory === CATEGORY_TRANSFER_FROM_USA_BANK_ACCOUNT ||
        record.providerFromCategory === CATEGORY_TRANSFER_FROM_BANK_OFAKIM
    ) {
        return status >= STATUS_OK;
    } else if (record.providerFromCategory === CATEGORY_TRANSFER_FROM_INTERAC) {
        return status >= STATUS_OK;
    } else if (record.providerFromCategory === CATEGORY_TRANSFER_FROM_PEOPLE_TRUST_INTERAC) {
        return status >= STATUS_OK;
    } else if (record.providerFromCategory === CATEGORY_ACCOUNT_DEBIT_VIA_MODULR && status < STATUS_OK) {
        return false;
    } else if (record.transactionType === PS_BONUS_INCOMING) {
        return false;
    } else if (status < STATUS_OK && record.secretCode === null && record.providerToCategory === CATEGORY_TRANSFER_TO_CASH) {
        return false;
    } else if (
        (record.providerToCategory === CATEGORY_TRANSFER_TO_INTERAC || record.providerToCategory === CATEGORY_TRANSFER_TO_PEOPLE_TRUST_INTERAC) &&
        status <= STATUS_SENDING_INTERAC &&
        record.toInteracPaymentType &&
        record.toInteracPaymentType === 'ALIAS_AUTODEPOSIT'
    ) {
        return false;
    } else if (
        ((record.providerToCategory === CATEGORY_TRANSFER_TO_INTERAC || record.providerToCategory === CATEGORY_TRANSFER_TO_PEOPLE_TRUST_INTERAC) &&
            status === STATUS_SENDING_INTERAC &&
            !record.secretCode) ||
        (record.secretCode !== null &&
            (record.providerToCategory === CATEGORY_TRANSFER_TO_CASH || record.providerToCategory === CATEGORY_TRANSFER_TO_HOME_DELIVERY))
    ) {
        return false;
    }
    return typeof record.billId === 'number' ? record.billId === 0 : false;
};

export const getDraftIconForButton = (chequeExtra: ChequeExtra = {}): string | undefined => {
    if (chequeExtra.draftCompletedVerification || chequeExtra.fraudNeedFieldsInfo || chequeExtra.fraudCompletedVerification || chequeExtra.fraudIncreaseLimitDetails) {
        return 'arrow-forward';
    } else if (chequeExtra.draftInProgressShowSupportButton || chequeExtra.draftOnfidoTooManyAttempts || chequeExtra.fraudNeedChat) {
        return 'message-bubble';
    } else if (chequeExtra.draftOnfidoCheckError) {
        return 'retry';
    } else if (chequeExtra.draftSkippedVerification || chequeExtra.fraudManualCheck) {
        return 'id-card';
    } else if (chequeExtra.fraudChequeRecipientDetails) {
        return 'alert';
    } else if (chequeExtra.fraudCardValidation) {
        return 'card-alert-80';
    } else if (chequeExtra.fraudAddressValidation) {
        return 'home-check';
    }
    return undefined;
};

export const getRequestDirectionClass = (incoming?: boolean): string => {
    return incoming ? OUTOGOING : INCOMING;
};

export const getStatusIconForBill = (status: string): string | undefined => {
    if (status === 'expired') {
        return 'alert';
    } else if (status === 'payed') {
        return 'check-rounded';
    } else if (status === 'waiting' || status === 'created') {
        return 'clock-filled';
    } else if (status === 'unpayed' || status === 'canceled') {
        return 'cross-rounded';
    }
};

export const getColorForBill = (status: string): string => {
    if (status === 'unpayed' || status === 'canceled' || status === 'expired') {
        return 'lightGray';
    } else if (status === 'waiting' || status === 'created') {
        return 'secondary';
    } else {
        return 'primary';
    }
};

export const isStatusFailedForBill = (status: string): boolean => {
    return status === 'unpayed' || status === 'canceled' || status === 'expired';
};

export const canPayBill = (bill?: Bill): boolean => {
    return Boolean(bill?.incoming && bill.status === 'created');
};

export const canDeclineBill = (bill?: Bill): boolean => {
    if (!bill) return false;
    const { direction, status } = bill;
    return (direction === 'IN' || direction === 'OUT') && (status === 'created' || status === 'waiting');
};

export const getIconForDiskBadge = (record: TransferRecord, providerToCategory?: number, transactionType?: string): string | null => {
    const billId = record.billId;
    if (record.avatar || (typeof billId === 'number' && billId > 0)) {
        return null;
    } else if (
        providerToCategory === CATEGORY_TRANSFER_TO_BANK_ACCOUNT ||
        providerToCategory === CATEGORY_TRANSFER_TO_SEPA ||
        providerToCategory === CATEGORY_TRANSFER_TO_REMITEE
    ) {
        return 'bank';
    } else if (providerToCategory === CATEGORY_TRANSFER_VIA_SWIFT) {
        return 'globe';
    } else if (
        (providerToCategory === CATEGORY_TRANSFER_TO_WALLET && record.toCountryId === PAKISTAN) ||
        providerToCategory === CATEGORY_TRANSFER_TO_CARD_VIA_PHONE_NUMBER
    ) {
        return 'mobile';
    } else if (providerToCategory === CATEGORY_TRANSFER_TO_WALLET) {
        return 'wallet';
    } else if (providerToCategory === CATEGORY_TRANSFER_TO_GCASH_WALLET) {
        return 'g-cash';
    } else if (providerToCategory === CATEGORY_TRANSFER_TO_ALIPAY) {
        return 'alipay';
    } else if (providerToCategory === CATEGORY_TRANSFER_TO_UPI) {
        return 'upi';
    } else if (providerToCategory === CATEGORY_TRANSFER_TO_WECHAT) {
        return 'wechat';
    } else if (
        providerToCategory === CATEGORY_TRANSFER_TO_CASH ||
        providerToCategory === CATEGORY_TRANSFER_TO_HOME_DELIVERY ||
        providerToCategory === CATEGORY_TRANSFER_TO_CASH_UNITELLER
    ) {
        return 'cash-stack';
    } else if (transactionType === PS_BONUS_INCOMING) {
        return 'gift';
    } else if (providerToCategory === CATEGORY_TRANSFER_TO_INTERAC) {
        return 'interac';
    } else if (providerToCategory === CATEGORY_TRANSFER_TO_PEOPLE_TRUST_INTERAC) {
        return 'bank';
    } else if (providerToCategory === CATEGORY_TRANSFER_TO_LIBRE) {
        return 'person';
    } else if (providerToCategory === CATEGORY_TRANSFER_TO_GLOBAL_ACCOUNT) {
        return 'safe';
    } else {
        return 'card';
    }
};

type AccountValue = string | number | null | undefined;

export const getToAccount = (
    providerToCategory?: number,
    toCountryId?: number | string | null,
    accountTo: AccountValue = '',
    messages: HistoryMessages = {},
): string | number | null | undefined => {
    let providerTo: string | undefined;
    if (
        providerToCategory === CATEGORY_TRANSFER_TO_CARD ||
        providerToCategory === CATEGORY_TRANSFER_TO_VISA_CARD ||
        providerToCategory === CATEGORY_TRANSFER_TO_UNIONPAY_CARD ||
        providerToCategory === CATEGORY_TRANSFER_TO_UNITELLER_MASTER_CARD
    ) {
        providerTo = messages.chequeBlockToCard;
    } else if (providerToCategory === CATEGORY_TRANSFER_TO_WALLET && toCountryId === PAKISTAN) {
        providerTo = messages.chequeBlockToMobile;
    } else if (providerToCategory === CATEGORY_TRANSFER_TO_CARD_VIA_PHONE_NUMBER) {
        providerTo = messages.chequeBlockToCardViaMobile;
    } else if (providerToCategory === CATEGORY_TRANSFER_TO_WALLET || providerToCategory === CATEGORY_TRANSFER_TO_GCASH_WALLET) {
        providerTo = messages.chequeBlockToWallet;
    } else if (
        providerToCategory === CATEGORY_TRANSFER_TO_BANK_ACCOUNT ||
        providerToCategory === CATEGORY_TRANSFER_TO_SEPA ||
        providerToCategory === CATEGORY_TRANSFER_TO_REMITEE ||
        providerToCategory === CATEGORY_TRANSFER_VIA_SWIFT ||
        providerToCategory === CATEGORY_TRANSFER_TO_WECHAT ||
        providerToCategory === CATEGORY_TRANSFER_TO_ALIPAY
    ) {
        providerTo = messages.chequeBlockToAccount;
    } else if (providerToCategory === CATEGORY_TRANSFER_TO_CASH) {
        providerTo = messages.blockToCash;
    } else if (providerToCategory === CATEGORY_TRANSFER_TO_CASH_UNITELLER) {
        providerTo = !accountTo ? messages.blockToCash : messages.blockToUniteller;
    } else if (providerToCategory === CATEGORY_TRANSFER_TO_HOME_DELIVERY) {
        return messages.chequeBlockToHomeDelivery;
    } else if (
        providerToCategory === CATEGORY_TRANSFER_TO_UPI ||
        providerToCategory === CATEGORY_TRANSFER_TO_INTERAC ||
        providerToCategory === CATEGORY_TRANSFER_TO_PEOPLE_TRUST_INTERAC
    ) {
        providerTo = messages.chequeBlockToInterac;
    }
    let sliceAccountTo: AccountValue = typeof accountTo === 'string' ? accountTo.slice(-4) : accountTo;
    if (
        providerToCategory === CATEGORY_TRANSFER_TO_INTERAC ||
        providerToCategory === CATEGORY_TRANSFER_TO_PEOPLE_TRUST_INTERAC ||
        providerToCategory === CATEGORY_TRANSFER_TO_ALIPAY ||
        providerToCategory === CATEGORY_TRANSFER_TO_UPI ||
        providerToCategory === CATEGORY_TRANSFER_TO_CASH_UNITELLER ||
        providerToCategory === CATEGORY_TRANSFER_TO_GLOBAL_ACCOUNT
    ) {
        sliceAccountTo = accountTo;
    }
    return providerTo ? resolveArguments(providerTo, sliceAccountTo) : sliceAccountTo;
};

export const getTableTitleColor = (cheque: TransferRecord): string => {
    const status = toNumberStatus(cheque?.status);
    return (status > STATUS_OK && !cheque.draft) ||
        cheque?.status === 'unpayed' ||
        cheque?.status === 'canceled' ||
        cheque?.status === 'expired' ||
        cheque?.extra?.draftOnfidoTooManyAttempts
        ? 'lightGray'
        : 'secondary';
};

export const getTableTextColor = (cheque: TransferRecord): string => {
    const status = toNumberStatus(cheque?.status);
    return (status > STATUS_OK && !cheque.draft) ||
        cheque?.status === 'unpayed' ||
        cheque?.status === 'canceled' ||
        cheque?.status === 'expired' ||
        cheque?.extra?.draftOnfidoTooManyAttempts
        ? 'lightGray'
        : 'primary';
};

export const getTextPlusSubscriptionColor = (cheque: TransferRecord): string => {
    const status = toNumberStatus(cheque.status);
    return (status > STATUS_OK && !cheque.draft) ||
        cheque.status === 'unpayed' ||
        cheque.status === 'canceled' ||
        cheque.status === 'expired' ||
        cheque.extra?.draftOnfidoTooManyAttempts
        ? 'lightGray'
        : 'primary';
};

export const getTextColorFromStatus = (isDisabled: boolean): string => {
    return isDisabled ? 'lightGray' : 'primary';
};

export const getStatusIcon = (status?: number | string): string | undefined => {
    const numericStatus = toNumberStatus(status);
    if (numericStatus > STATUS_OK) {
        return 'cross-rounded';
    } else if (numericStatus === STATUS_OK) {
        return 'check';
    } else if (numericStatus < STATUS_OK) {
        return 'clock';
    }
};

export const getSendHistoryIcon = (cheque: TransferRecord): string | undefined => {
    if (cheque.draft || cheque.draftFraud) {
        if (cheque.extra?.draftOnfidoTooManyAttempts || cheque.extra?.draftOnfidoCheckError) {
            return 'cross-rounded';
        } else if (cheque.extra?.fraudChequeRecipientDetails) {
            return 'info-rounded';
        } else if (cheque.extra?.fraudAddressValidation) {
            return 'info-rounded';
        } else if (cheque.extra?.fraudIncreaseLimitDetails) {
            return 'info-rounded';
        } else {
            return 'clock';
        }
    }
    return getStatusIcon(cheque.status);
};

export const getIbanWithWhitespace = (iban: string): string => {
    if (iban.includes('-')) {
        return iban;
    } else {
        let ibanWithWhitespace = '';
        for (let i = 0; i < iban.length; i = i + 4) {
            ibanWithWhitespace = ibanWithWhitespace + iban.substring(i, i + 4) + ' ';
        }
        return ibanWithWhitespace;
    }
};

export const isShowHowToPay = (cheque: TransferRecord = {}): boolean => {
    const status = toNumberStatus(cheque.status);
    return status < STATUS_OK && Boolean(cheque.fromBankAccountStatusBean) && !cheque.fromPlaid && cheque.providerFromCategory !== CATEGORY_TRANSFER_FROM_TINK;
};

export const getStatusText = (cheque: TransferRecord = {}, messages: HistoryMessages = {}, lastStatus?: LastStatus | null): string | undefined => {
    let statusText = messages?.chequeStatusInProgress;
    const statusValue = toNumberStatus(cheque.status);

    if (lastStatus !== null) {
        return lastStatus?.statusMsg;
    }

    if (cheque.draft || cheque.draftFraud) {
        statusText = messages?.draftChequeStatus;
    } else if (isSpecialStatus(cheque)) {
        statusText = messages?.chequeStatus70specialTitle;
    } else if (
        statusValue < STATUS_OK &&
        (cheque.providerToCategory === CATEGORY_TRANSFER_TO_INTERAC || cheque.providerToCategory === CATEGORY_TRANSFER_TO_PEOPLE_TRUST_INTERAC) &&
        cheque.secretCode
    ) {
        statusText = messages?.chequeInteracStatusInProgress;
    } else if (
        statusValue < STATUS_OK &&
        (cheque.providerToCategory === CATEGORY_TRANSFER_TO_CASH || cheque.providerToCategory === CATEGORY_TRANSFER_TO_CASH_UNITELLER) &&
        cheque.secretCode
    ) {
        statusText = messages?.chequeCashStatusInProgress;
        if (cheque.toCountryId === VIETNAM && !cheque.vietcombank) {
            statusText = messages?.chequeCashStatusNotVietcombankInProgress;
        }
    } else if (statusValue > 10 && statusValue < STATUS_OK && cheque.providerToCategory === CATEGORY_TRANSFER_TO_HOME_DELIVERY) {
        statusText = messages?.chequeHomeDeliveryStatusInProgress;
    } else if (
        statusValue === STATUS_OK &&
        (cheque.providerToCategory === CATEGORY_TRANSFER_TO_INTERAC || cheque.providerToCategory === CATEGORY_TRANSFER_TO_PEOPLE_TRUST_INTERAC)
    ) {
        statusText = messages?.chequeInteracStatusSuccess;
    } else if (statusValue === STATUS_OK && cheque.providerToCategory === CATEGORY_TRANSFER_TO_HOME_DELIVERY) {
        statusText = messages?.chequeHomeDeliveryStatusSuccess;
    } else if (
        statusValue === STATUS_OK &&
        (cheque.providerToCategory === CATEGORY_TRANSFER_TO_CASH || cheque.providerToCategory === CATEGORY_TRANSFER_TO_CASH_UNITELLER)
    ) {
        statusText = messages?.chequeHomeDeliveryStatusSuccess;
    } else if (statusValue < STATUS_OK && cheque.waitingVerification) {
        statusText = messages?.chequeStatusWaitingVerification;
    } else if (
        statusValue < STATUS_OK &&
        (cheque.providerFromCategory === CATEGORY_TRANSFER_FROM_INTERAC || cheque.providerFromCategory === CATEGORY_TRANSFER_FROM_PEOPLE_TRUST_INTERAC)
    ) {
        statusText = messages?.chequeFromInteracStatusInProgress;
    }

    return statusText;
};

const isSpecialStatus = (chequeSpecialStatus: TransferRecord): boolean => {
    const status = toNumberStatus(chequeSpecialStatus.status);
    return status === STATUS_SENDING_70 && (chequeSpecialStatus.toBankCountryCode === 'uz' || chequeSpecialStatus.toBankCountryCode === 'ua');
};

export const getSpecialStatus = (cheque: TransferRecord = {}, messages: HistoryMessages = {}, lastStatus: LastStatus = {}): string | null => {
    let statusMessage;
    const statusMessageByPaymentHistory = lastStatus?.statusDescription;
    const statusValue = toNumberStatus(cheque.status);
    if (isSpecialStatus(cheque)) {
        statusMessage = messages?.chequeStatus70specialSubtitle;
    } else if (
        statusValue > 10 &&
        statusValue < STATUS_OK &&
        (cheque.providerToCategory === CATEGORY_TRANSFER_TO_PEOPLE_TRUST_INTERAC || cheque.providerToCategory === CATEGORY_TRANSFER_TO_INTERAC) &&
        cheque.toInteracPaymentType &&
        cheque.toInteracPaymentType === 'ALIAS_AUTODEPOSIT'
    ) {
        statusMessage = messages?.chequeInteracStatusAutoDepositInfo;
    }
    statusMessage = statusMessageByPaymentHistory || statusMessage;
    if (statusMessage) {
        return statusMessage;
    }
    return null;
};
